import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "../context/AuthContext";

export default function Auth({ mode }) {
  const isLogin = mode === "login";
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      if (isLogin) await login(email, password);
      else await register(name, email, password);
      const dest = location.state?.from || "/account";
      navigate(dest);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-16 bg-[#F8F9FA]">
      <div className="w-full max-w-md bg-white rounded-3xl border border-gray-100 shadow-[0_8px_40px_rgb(0,0,0,0.05)] p-8">
        <div className="flex items-center justify-center mb-6">
          <img src="/meow-care-logo-v2.png" alt="Meow Care Love" className="h-16 w-auto object-contain" />
        </div>
        <h1 className="font-display font-black text-3xl text-center mb-1">{isLogin ? "Welcome back" : "Create your account"}</h1>
        <p className="text-gray-500 text-center mb-8 text-sm">{isLogin ? "Log in to track orders and care plans." : "Join 13,000+ owners caring for their cats."}</p>

        {error && <div data-testid="auth-error" className="bg-red-50 text-red-600 text-sm rounded-xl px-4 py-3 mb-4">{error}</div>}

        <form onSubmit={submit} className="space-y-4">
          {!isLogin && (
            <input data-testid="auth-name" required value={name} onChange={(e) => setName(e.target.value)} placeholder="Full name"
              className="w-full bg-[#F8F9FA] border border-gray-200 rounded-xl px-4 py-3 focus:outline-none focus:border-[#FF5C28]" />
          )}
          <input data-testid="auth-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email address"
            className="w-full bg-[#F8F9FA] border border-gray-200 rounded-xl px-4 py-3 focus:outline-none focus:border-[#FF5C28]" />
          <input data-testid="auth-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password"
            className="w-full bg-[#F8F9FA] border border-gray-200 rounded-xl px-4 py-3 focus:outline-none focus:border-[#FF5C28]" />
          <button data-testid="auth-submit" disabled={loading}
            className="w-full rounded-full bg-[#FF5C28] text-white font-bold px-8 py-4 hover:bg-[#E04D1E] transition-colors disabled:opacity-60">
            {loading ? "Please wait…" : isLogin ? "Log in" : "Create account"}
          </button>
        </form>

        <p className="text-center text-sm text-gray-500 mt-6">
          {isLogin ? "New here? " : "Already have an account? "}
          <Link data-testid="auth-switch" to={isLogin ? "/register" : "/login"} className="font-bold text-[#FF5C28] hover:underline">
            {isLogin ? "Create an account" : "Log in"}
          </Link>
        </p>
      </div>
    </div>
  );
}
